import { render, staticRenderFns } from "./ClientSuggestion.vue?vue&type=template&id=71ed3754&scoped=true"
import script from "./ClientSuggestion.vue?vue&type=script&lang=js"
export * from "./ClientSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed3754",
  null
  
)

export default component.exports